import { FC } from 'react';
import { DashboardCard, DashboardCardProps } from './dashboard-card/dashboard-card';
import s from './dashboard-cards.module.css';

interface Props {
  cards?: DashboardCardProps[];
}
export const DashboardCards: FC<Props> = ({ cards }) => {
  if (!cards?.length) return null;

  return (
    <ul className={s.feature}>
      {cards.map((card) => (
        <DashboardCard key={card.title} {...card} />
      ))}
    </ul>
  );
};
